import { Navigate, RouteObject } from 'react-router-dom';

import HouseholdMembersScreen from '../components/household-member/HouseholdMembersScreen';
import PaymentsScreen from '../components/payments/PaymentsScreen';
import { AccountDetailsScreen } from '../components/account-details/AccountDetailsScreen';
import LanguageScreen from '../components/language/LanguageScreen';
import PrivacyScreen from '../components/privacy/PrivacyScreen';
import SecuritySettingsScreen from '../components/security-settings/SecuritySettingsScreen';
import PasswordScreen from '../components/security-settings/PasswordScreen';
import TwoFactorAuthentication from '../components/security-settings/MfaAuthentication';

export const DEFAULT_SETTINGS_ROUTE = 'account-details';

export const createSettingsRoutes = (isHouseholdMember: boolean): Array<RouteObject> => {
  const routes: Array<RouteObject> = [
    { index: true, element: <Navigate to={DEFAULT_SETTINGS_ROUTE} replace /> },
    { path: 'account-details', element: <AccountDetailsScreen /> },
    { path: 'payments', element: <PaymentsScreen /> },
    { path: 'language', element: <LanguageScreen /> },
    {
      path: 'security-settings',
      children: [
        { index: true, element: <SecuritySettingsScreen /> },
        { path: 'mfa-authentication', element: <TwoFactorAuthentication /> },
        { path: 'password-update', element: <PasswordScreen /> },
      ],
    },
    { path: 'privacy', element: <PrivacyScreen /> },
  ];

  if (!isHouseholdMember) {
    routes.splice(2, 0, { path: 'household-members', element: <HouseholdMembersScreen /> });
  }

  return routes;
};

export const SettingsRoutes: Array<RouteObject> = createSettingsRoutes(false);
